<script src="https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js" integrity="sha384-jhGcGHNZytnBnH1wbEM3KxJYyRDy9Q0QLKjE65xk+aMqXFCdvFuYIjzMWAAWBBtR" crossorigin="anonymous"></script>
<div class="fluid-container">
    <form class="change-password-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div>
            <p class="img-container">
                <a href="https://www.avantis.co.in">
                    <img src="../../../assets/Images/TeamLeaseRegtech_Logo_new.png" class="teamlease-img">
                </a>
            </p>
        </div>

        <div>
            <h1 class="form-header">Change Password</h1>
            <div class=" f-textbox"
                [ngClass]="{'is-invalid': form.get('oldPassword')?.invalid && form.get('oldPassword')?.touched}">

                <input #oldPasswordInput [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword"
                    placeholder="Current Password" class=" form-control masking" maxlength="50" (keydown.tab)="focusNewPassword($event)"
                    [(ngModel)]="oldPassword" (keydown.space)="$event.preventDefault()" (keydown.enter)="$event.preventDefault()" />

                <button type="button" class="figma-btn-white" (click)="toggleOldPasswordVisibility()">
                    <img *ngIf="showOldPassword" src="../assets/vectors/eye_112_x2.svg" alt="Toggle Current Password"
                        title="Hide Password" />
                    <img *ngIf="!showOldPassword" src="../assets/vectors/EyeClosed.svg" alt="Toggle Current Password"
                        title="Show Password" />
                </button>
            </div>
            <div *ngIf="form.get('oldPassword')?.hasError('minlength') && form.get('oldPassword')?.touched">
                <small class="text-danger">Password must be at least 8 characters long.</small>
            </div>
            <div class=" f-textbox" (keydown.tab)="focusConfirmPassword($event)" 
                [ngClass]="{'is-invalid':(form.get('newPassword')?.invalid && form.get('newPassword')?.touched)|| (passwordMismatch==true)||(strengthCheck(newPassword)!='')}">
                <input  #newPasswordInput [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
                    placeholder="New Password" class="form-control masking" maxlength="50" [(ngModel)]="newPassword" 
                    (keydown.space)="$event.preventDefault()" (keydown.enter)="$event.preventDefault()" />

                <button type="button" class="figma-btn-white" (click)="toggleNewPasswordVisibility()">
                    <img *ngIf="showNewPassword" src="../assets/vectors/eye_112_x2.svg" alt="Toggle New Password"
                        title="Hide Password" />
                    <img *ngIf="!showNewPassword" src="../assets/vectors/EyeClosed.svg" alt="Toggle New Password"
                        title="Show Password" />
                </button>
            </div>
            <div *ngIf="strengthCheck(newPassword)!='' " >
                <small class="text-danger">{{ strengthCheck(newPassword) }}</small>
              </div>
              <!-- <div *ngIf="form.get('newPassword')?.hasError('minlength') && form.get('newPassword')?.touched">
                <small class="text-danger">Password must be at least 8 characters long.</small>
            </div> -->
           
            <div  class=" f-textbox" [ngClass]="passwordMismatch ? 'margin-zero' : ''"
                [ngClass]="{'is-invalid': (form.get('confirmNewPassword')?.invalid && form.get('confirmNewPassword')?.touched)||passwordMismatch==true}">
                <input #confirmPasswordInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmNewPassword" (keyup)="checkNewPassword()"
                    placeholder="Confirm Password" class=" form-control  masking" maxlength="50" (keydown.tab)="focusSubmitPassword($event)"
                    [(ngModel)]="confirmNewPassword" (keydown.space)="$event.preventDefault()" (keydown.enter)="$event.preventDefault()" />

                <button type="button" class="figma-btn-white" (click)="toggleConfirmPasswordVisibility()">
                    <img *ngIf="showConfirmPassword" src="../assets/vectors/eye_112_x2.svg" title="Hide Password"
                        alt="Toggle Confirm Password" />
                    <img *ngIf="!showConfirmPassword" src="../assets/vectors/EyeClosed.svg" title="Show Password"
                        alt="Toggle Confirm Password" />
                </button>
            </div>
            <div *ngIf="form.get('confirmNewPassword')?.hasError('minlength') && form.get('confirmNewPassword')?.touched">
                <small class="text-danger">Password must be at least 8 characters long.</small>
            </div>
            <small class="text-danger" *ngIf="passwordMismatch">
                New Password and Confirm Password do not match. 
            </small>
        </div>

        <div class="button-group">
            <button title="Clear" class="clear-btn" (click)="onClear()">Clear</button>
            <button title="Submit" class="submit-btn" #SubmitPasswordInput  type="submit">Submit</button>
        </div>
        <p class="footer-link" (click)="goBack()">
            <a>Click here to go back</a>
        </p>
    </form>
</div>
<app-alert-popup *ngIf="alertData.alertVisible" [Width]="270" [Data]="alertData"
    (close)="closeAlert()"></app-alert-popup>
<div *ngIf="loading" class="loader-overlay">
    <kendo-loader type="converging-spinner" themeColor="primary" class="loader"></kendo-loader>
</div>